<span class="drawer-label">{{ label }}</span>
<div class="shadow-field-wrapper">
  <div>
    <label
      class="shadow-attribute"
      i18n-tooltip="@@X-axis offset (px)"
      tooltip="X-axis offset (px)"
      placement="top"
    >
      <span>X</span>
      <input type="text" [value]="initialX" />
    </label>
  </div>
  <div>
    <label
      class="shadow-attribute"
      i18n-tooltip="@@Y-axis offset (px)"
      tooltip="Y-axis offset (px)"
      placement="top"
    >
      <span>Y</span>
      <input type="text" [value]="initialY" />
    </label>
  </div>
  <div>
    <label
      class="shadow-attribute"
      i18n-tooltip="@@Shadow blur (px)"
      tooltip="Shadow blur (px)"
      placement="top"
    >
      <span>B</span>
      <input type="text" [value]="initialB" />
    </label>
  </div>
  <div>
    <label
      class="shadow-attribute"
      i18n-tooltip="@@Spread (px)"
      tooltip="Spread (px)"
      placement="top"
    >
      <span>S</span>
      <input type="text" [value]="initialS" />
    </label>
  </div>
  <div>
    <app-configurator-color-field
      [opacity]="colorOpacity"
      initialColor="#000000"
    >
    </app-configurator-color-field>
  </div>
</div>
